export enum OfferController {
    offer = 'offer',
    matches = 'matches',
}

export enum OfferMethods {
    offerByDate = 'getOfferByDate',
    superOffer = 'getSuperOfferByDate',
    topTen = 'getTopTenOffer',
    struct = 'getOfferStruct',
    matchesByIds = 'getMatchesByIds',
}

export enum OfferStatus {
    active = 'active',
    stop = 'stop',
    block = 'block',
    finished = 'finished',
    canceled = 'canceled'
}

export enum OfferState {
    prematch = 'prematch',
    live = 'live',
}

export enum SocketEvents {
    getData = 'getData',
    getDataCompressed = 'getDataCompressed',
    eventChange = 'matchchange',
    offerChange = 'offerchange',
    addSubscription = 'addSubscription',
    removeSubscription = 'removeSubscription',
    liveCountChange = 'liveEventsNum',
    Sport = 'sport',
    Category = 'category',
    Tournament = 'tournament',
    BetGroup = 'betGroup',
    OddType = 'oddType',
    MarketGroup = 'marketGroup',
    Connect = 'connect',
    Reconnect = 'reconnect',
    Disconnect = 'disconnect',
    structChange = 'treechange',
}

export enum CurrentOfferStatus {
    active = 'active',
    finished = 'finished',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/offer/_private/models/enums.ts